var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useLanguage } from '@base/LanguageProvider';
import { entryLinkKeys, useDisableEntryLink, useEntryLink, useEntryLinkByKey } from '@data/entryLink/entryLinkActions';
import useModelTable from '@data/hooks/modelTable';
import { useActiveVersions } from '@data/hooks/versions';
import { useTagContext } from '@data/tag/tagContext';
import FarseerLogo from '@shared/icons/FarseerLogo';
import { XTable } from '@shared/tablechart/table';
import Tags from '@shared/tags/Tags';
import { ELHeader, ELHeaderLogo, ELWrap } from '@styled/EntryLinks';
import { useQueryClient } from '@tanstack/react-query';
import React, { useMemo } from 'react';
import EntryLinksToolbar from './EntryLinksToolbar';
//@ts-ignore
import { useBranch } from 'baobab-react/hooks';
import { useParams } from 'react-router-dom';
import FSButton from '../../components/FSButton';
import { useActiveYears } from '../../data/hooks/timePoints';
import { useSelectedSheetRow, useRootSheetRow } from '../../data/sheetRow/sheetRowHooks';
import { TagQueryKeys } from '../../data/tag/types';
import IntervalToolbar from '../../main/flow/IntervalToolbar';
import Manager from '../../shared/modal/Manager';
import { Confirmation } from '../../shared/modal/Simple';
import { Loading } from '../../styled/Basic';
import { handleApiErrorMessage } from '../../util/message';
import { sheetRowKeys } from '../../data/sheetRow/sheetRowActions';
import { useAuth } from '../../providers/AuthProvider';
function SubmitEntryLinkModal(props) {
    var L = useLanguage().L;
    var entryLinkId = props.entryLinkId;
    var entryLink = useEntryLink(entryLinkId).data;
    var disableEntryLink = useDisableEntryLink();
    return (React.createElement(Confirmation, { width: 400, title: React.createElement("span", null, L('Submit')), loading: disableEntryLink.isLoading, yesBtn: L('Submit'), onOk: function () {
            if (entryLink === null || entryLink === void 0 ? void 0 : entryLink.id) {
                disableEntryLink.mutate([entryLink.id], {
                    onSuccess: function () {
                        Manager.closeModal();
                    },
                });
            }
        } },
        React.createElement("span", null,
            L('You won’t be able to make any further chances after submitting and the link will be locked.'),
            React.createElement("br", null),
            " ",
            React.createElement("br", null),
            L('Are you sure you want to submit your entries?'))));
}
export function EntryLinksPage() {
    var L = useLanguage().L;
    var queryClient = useQueryClient();
    var entryLinkKey = useParams().entryLinkKey;
    var entryLink = useEntryLinkByKey(entryLinkKey, {
        notifyOnChangeProps: ['data'],
        refetchOnWindowFocus: false,
        onSettled: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, queryClient.refetchQueries(TagQueryKeys.Tags)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, queryClient.refetchQueries(TagQueryKeys.Relations)];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, queryClient.refetchQueries(TagQueryKeys.Actions)];
                        case 3:
                            _a.sent();
                            return [4 /*yield*/, queryClient.refetchQueries(sheetRowKeys.all)];
                        case 4:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        onError: function (err) {
            handleApiErrorMessage(err);
            queryClient.setQueryData(entryLinkKeys.detail(entryLinkKey), undefined);
        },
    }).data;
    var activeVersions = useActiveVersions();
    var activeYears = useActiveYears();
    var tagsLoading = useTagContext().tagsLoading;
    var userSettings = useAuth().settings;
    var dataLoaded = !tagsLoading && !!entryLink && entryLinkKey !== undefined;
    var rootSheetRow = useRootSheetRow(entryLink === null || entryLink === void 0 ? void 0 : entryLink.path);
    var selectedSheetRow = useSelectedSheetRow();
    var _a = useMemo(function () {
        if (!entryLink || !dataLoaded) {
            return {};
        }
        var startYear = entryLink.intervalStart.getFullYear();
        var endYear = entryLink === null || entryLink === void 0 ? void 0 : entryLink.intervalEnd.getFullYear();
        var years = [];
        if (endYear >= startYear) {
            for (var y = startYear; y <= endYear; y++) {
                if (!activeYears.includes(y)) {
                    continue;
                }
                years.push(y);
            }
        }
        var versions = [];
        var filtered = activeVersions.filter(function (v) { return entryLink.versionIds.includes(v.id); });
        if (filtered.length) {
            versions = filtered;
        }
        return { entryLinkActiveYears: years, entryLinkActiveVersions: versions };
    }, [
        dataLoaded,
        activeVersions,
        activeYears,
        entryLink === null || entryLink === void 0 ? void 0 : entryLink.versionIds,
        entryLink === null || entryLink === void 0 ? void 0 : entryLink.intervalEnd,
        entryLink === null || entryLink === void 0 ? void 0 : entryLink.intervalStart,
    ]), entryLinkActiveYears = _a.entryLinkActiveYears, entryLinkActiveVersions = _a.entryLinkActiveVersions;
    function submit() {
        if (entryLink === null || entryLink === void 0 ? void 0 : entryLink.id) {
            Manager.renderModal(React.createElement(SubmitEntryLinkModal, { entryLinkId: entryLink.id }));
        }
    }
    var now = Date.now();
    var hasExpired = false;
    if (entryLink === null || entryLink === void 0 ? void 0 : entryLink.expirationTime) {
        hasExpired = entryLink.expirationTime < new Date(now);
    }
    var isLoading = !entryLinkActiveYears || !entryLinkActiveVersions || !dataLoaded || !rootSheetRow;
    return (React.createElement(ELWrap, null,
        React.createElement(ELHeader, null,
            React.createElement(ELHeaderLogo, null,
                React.createElement(FarseerLogo, null)),
            !hasExpired && !isLoading && React.createElement(FSButton, { type: "submit", title: L('Submit'), onClick: submit })),
        isLoading ? (React.createElement("div", { style: { display: 'grid', placeItems: 'center', height: '100%', width: '100%' } },
            React.createElement(Loading, null))) : hasExpired ? (React.createElement("div", { style: { display: 'grid', placeItems: 'center', height: '100%', width: '100%', fontSize: 22 } }, L(!entryLink ? 'Link not found.' : 'This link has expired.'))) : (React.createElement(React.Fragment, null,
            React.createElement(Tags, { tags: selectedSheetRow ? selectedSheetRow.allTags : rootSheetRow.allTags, canUpdate: false, singleLine: true, style: { padding: '10px 20px' } }),
            React.createElement(EntryLinksToolbar, { userSettings: userSettings, activeVersions: entryLinkActiveVersions !== null && entryLinkActiveVersions !== void 0 ? entryLinkActiveVersions : [] }),
            React.createElement(EntryLinksTable, { activeVersions: entryLinkActiveVersions !== null && entryLinkActiveVersions !== void 0 ? entryLinkActiveVersions : [], userSettings: userSettings, rootSheetRow: rootSheetRow, selectedSheetRow: selectedSheetRow !== null && selectedSheetRow !== void 0 ? selectedSheetRow : rootSheetRow }),
            React.createElement(IntervalToolbar, { showColumnManager: false, activeYears: entryLinkActiveYears, activeVersions: entryLinkActiveVersions })))));
}
function EntryLinksTable(_a) {
    var userSettings = _a.userSettings, activeVersions = _a.activeVersions, rootSheetRow = _a.rootSheetRow, selectedSheetRow = _a.selectedSheetRow;
    var loadingInProgress = useBranch({
        loadingInProgress: ['state', 'loadingInProgress'],
    }).loadingInProgress;
    var modelTableData = useModelTable(rootSheetRow, selectedSheetRow, activeVersions);
    return modelTableData.modelTable.initialLoad && loadingInProgress ? (React.createElement("div", { style: { flexGrow: 1, width: '100%', position: 'relative', display: 'grid', placeItems: 'center' } },
        React.createElement(Loading, null))) : (React.createElement(React.Fragment, null,
        React.createElement(XTable, { modelTableData: modelTableData, tableKey: "EntryLinksTable", containerHeight: window.innerHeight - 190, numberFormatType: userSettings.number_format_type })));
}
